import React from "react";
import { MapPin, Clock, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KdeNasNajdete() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll();
  return <section id="kde-nás-najdete" className="relative w-full h-[600px] md:h-[700px] bg-muted overflow-hidden">
      {/* Map Background */}
      <div className="absolute inset-0 w-full h-full">
        <iframe className="w-full h-full grayscale contrast-125 opacity-90" frameBorder="0" scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?q=Vršovice,+Prague&t=&z=14&ie=UTF8&iwloc=&output=embed" title="S-clean prádelna Vršovice Location" aria-label="Mapa umístění prádelny" />
        {/* Overlay for better contrast */}
        <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-transparent to-transparent pointer-events-none md:via-background/20" />
      </div>

      {/* Content Card */}
      <div className="container mx-auto h-full relative z-10 pointer-events-none flex items-center justify-center md:justify-start px-4">
        <div ref={cardRef} className={`w-full max-w-md pointer-events-auto transition-all duration-700 ease-out transform ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="shadow-2xl border-border/40 bg-card/95 backdrop-blur-md">
            <CardHeader className="pb-4">
              <CardTitle className="text-2xl font-bold text-primary flex items-center gap-2">
                <MapPin className="size-6 text-secondary" />
                Kde nás najdete
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="space-y-2">
                <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                  Adresa provozovny
                </h3>
                <p className="text-lg font-medium text-foreground">
                  Vršovice, Prague
                  <br />
                  Czech Republic
                </p>
              </div>

              <div className="space-y-2">
                <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider flex items-center gap-2">
                  <Clock className="size-4" />
                  Provozní doba
                </h3>
                <p className="text-base text-foreground">
                  <span className="font-semibold text-primary">24/7</span>{" "}
                  noční svoz a doručení
                </p>
                <p className="text-sm text-muted-foreground">
                  Specializujeme se na noční logistiku pro nepřetržitý provoz
                  vašeho podnikání.
                </p>
              </div>
            </CardContent>
            <CardFooter className="pt-2">
              <Button asChild className="w-full text-base py-6 shadow-lg" size="lg">
                <Link to="https://www.google.com/maps/dir//Vršovice,+Prague" newTab>
                  <Navigation className="mr-2 size-5" />
                  Navigovat do prádelny
                </Link>
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}